
import Api from './api'

export default {

    getUser: function () {

        return Api.get('/v3/users')

    },

    getSettings: function () {

        return Api.get('/v3/users/settings')

    },

    getStats: function () {

        return Api.get('/v3/users/stats')
    },

    updateUser: function ({firstname, lastname, birthYear, device}) {

        return Api.post('/v3/users/information', {firstname, lastname, birthYear, device})

    },

    updatePanel: function (email, bool) {

        return Api.put(`/v3/accounts/${ email }/settings`, { name: 'inFoxPanel', value: bool })

    },

    updateActive: function (email, bool) {

        return Api.put(`/v3/accounts/${ email }/settings`, { name: 'isActive', value: bool })

    },

    updateFetchNotifEmail: function (bool) {

        return Api.put('/v3/users/settings', { name: 'fetchNotifyByEmail', value: bool })

    },

    updateFetchLanguage: function (lang) {

        return Api.put('/v3/users/settings', { name: 'language', value: lang })

    },

    isRegisteredToPushNotifications: function(appInstanceId) {

        return Api.get(`/v3/users/settings?appInstanceId=${ appInstanceId }` )

    },

    getGDPR: function () {

        return Api.get('/v3/users/gdpr')

    }

}
